export const state = {
    secaoProduto: {},
    secoesProduto: [],
    modalCadastroSecaoProduto: false,
    modalExcluirSecaoProduto: false
}

export default {}